'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var Toggleable = require('../alloy-toggleable/Toggleable.js');

var keys = {
    left: 'ArrowLeft',
    right: 'ArrowRight'
};
var direction = {
    ArrowLeft: -1,
    ArrowRight: 1
};
var Tabs = function (_a) {
    var active = _a.active, children = _a.children, className = _a.className, onChange = _a.onChange, rest = tslib.__rest(_a, ["active", "children", "className", "onChange"]);
    var tabsRef = react.useRef(null);
    var handleArrowKeyUp = function (tabs) { return function (e) {
        var key = e.code;
        if (direction[key]) {
            // const { target as unknown as TabsType } = e;
            var target = e.target;
            if (target.index !== undefined) {
                var tabToFocus = null;
                if (tabs[target.index + direction[key]]) {
                    tabToFocus = tabs[target.index + direction[key]];
                }
                else if (key === keys.left) {
                    tabToFocus = tabs[tabs.length - 1];
                }
                else if (key === keys.right) {
                    tabToFocus = tabs[0];
                }
                if (tabToFocus) {
                    tabToFocus.focus();
                }
            }
        }
    }; };
    react.useEffect(function () {
        if (tabsRef.current) {
            var tabs_1 = tabsRef.current.querySelectorAll('[role="tab"]');
            var tabsArray_1 = Array.prototype.slice.call(tabs_1);
            tabsArray_1.forEach(function (tab, index) {
                tab.addEventListener('keyup', handleArrowKeyUp(tabsArray_1));
                tab.index = index;
            });
            return function () {
                tabs_1.forEach(function (tab) {
                    tab.removeEventListener('keyup', handleArrowKeyUp(tabsArray_1));
                });
            };
        }
    });
    return (jsxRuntime.jsx(Toggleable.default, tslib.__assign({ activeChildren: active, setActiveChildren: onChange }, { children: jsxRuntime.jsx("div", tslib.__assign({ ref: tabsRef, className: "d-flex flex-column ".concat(className ? className : '') }, rest, { children: children })) })));
};

exports.Tabs = Tabs;
//# sourceMappingURL=Tabs.js.map
